export default {"src":"/_next/static/media/trainyouravatar.14ffc804.svg","height":400,"width":500,"blurWidth":0,"blurHeight":0};